export default {
    createBranch: 'Create Branch',
    updateBranch: 'Edit Branch',
    branchName: 'Branch Name',
    branchAddress: 'Branch Address',
    contactPerson: 'Contact Person',
    contactPhoneNumber: 'Contact Phone Number',
    save: 'Save',
    thisFieldIsRequired: 'This field is required',
    incorrectPhoneNubmer: 'Incorrect phone nubmer',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    congratulation: 'Congratulation',
    errorMessage: 'Error message',
    branchIsCreated: 'Branch is created',
    branchIsUpdated: 'Branch is updated'
}
